<div class="container">
  <h5 class="fw-bold text-white p-2 rounded custom-header text-x">Identity Verification</h5>

  <div
    v-for="row in identity_rows"
    :key="row.key_label"
    class="p-2 mb-2 border rounded bg-white d-flex justify-content-between align-items-start"
  >
    <span class="fw-semibold text-xxs">{{ row.key_label }}</span>

    <div class="text-end">
      <div class="text-xxs" :class="row.class_name || ''">
        {{ row.value || '—' }}
        <span v-if="row.badge" class="badge ms-2" :class="row.badge.class_name">
          {{ row.badge.text }}
        </span>
      </div>

      <div v-if="row.verified_value" class="text-xxs text-muted">
        Verified: {{ row.verified_value }}
      </div>
    </div>
  </div>
</div>
